<template>
  <div id="Admin">

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <section
      v-else
      style="padding: 10px;font-size: 13px;">
      <div class="row">
        <div class="col-12">
          <h4>Active Users ({{ activeUsersCount }})</h4>
        </div>
      </div>

      <table
        class="table"
        width="100%">
        <thead>
          <tr>
            <th style="font-size: 13px;">No.</th>
            <th style="font-size: 13px;">Email</th>
            <th style="font-size: 13px;">Created</th>
            <th style="font-size: 13px;">Latest Active</th>
            <th style="font-size: 13px;">Shops</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in activeUsers">
            <td>{{ (index+1) }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.created_at }}</td>
            <td>{{ item.analytics.latest_active }}</td>
            <td>
              <div class="container-shops">
                <router-link
                  v-for="(shop, index_) in item.shops"
                  :key="index_"
                  :to="{
                    name: 'ShopDailySaleDetail',
                    query: {
                      shop_id: shop.shop_id
                    }
                }">
                  {{ shop.name }}
                </router-link>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

  </div>
</template>

<script>
export default {
  name: 'ShopDailySale',

  data () {
    return {
      ready: false,
    }
  },

  computed: {
    activeUsers () {
      return this.$store.getters['analytic/getState']('activeUsers')
    },

    activeUsersCount () {
      return this.activeUsers.length
    },
  },

  async created () {
    await this.$store.dispatch('analytic/getActiveUsers')
    this.ready = true
  },

}
</script>

<style scoped>
  .container-shops {
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/analytics/ShopDailySale.vue